import web from "../web";

class CategoriesgrillestarifairesService {
    index(token){
        return web.get("/api/categoriesgrillestarifaires", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/categoriesgrillestarifaires", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/categoriesgrillestarifaires/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/categoriesgrillestarifaires/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/categoriesgrillestarifaires/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new CategoriesgrillestarifairesService()